__turbopack_context__.v({
  "skeleton": "accessories-tab-module-scss-module__-jcMgG__skeleton",
  "skeletons": "accessories-tab-module-scss-module__-jcMgG__skeletons",
});
